'use client';
import React from 'react';
import Image from 'next/image';
import styled from 'styled-components';

import { SmallCard } from './SmallCard';
import { TableContent } from './TableContent';

import { useNewsletterModalContext } from '@/context/newsletter-modal.context';
import { ArticleCard } from '@/features/ArticleCard/ArticleCard';
import ClientOnly from '@/helpers/ClientOnly';
import { formatDate } from '@/helpers/formatDate';
import image from '@/public/article_image.png';
import { devices } from '@/styles/breakpoints';

export const Detailed = ({ data, articles, type }) => {
  const { setIsModalOpened } = useNewsletterModalContext();

  const parsedImage = JSON.parse(data.image);

  const sections = JSON.parse(data?.sections);

  return (
    <Wrapper>
      {/* <ImageWrapper>
        <Image
          className="main-image"
          width={343}
          height={200}
          src={parsedImage?.[0]?.source}
          alt={data?.meta_title}
        />
      </ImageWrapper>
      <Title>{data?.title}</Title>
      <TimeStamp>{formatDate(data?.updated_at)}</TimeStamp> */}
      <Content>
        <LeftSide>
          <ImageWrapper>
            <Image
              className="main-image"
              width={343}
              height={200}
              src={parsedImage?.[0]?.source}
              alt={data?.meta_title}
            />
          </ImageWrapper>
          <Title>{data?.title}</Title>
          <TimeStamp>{formatDate(data?.updated_at)}</TimeStamp>
          <ClientOnly>
            {sections.map((item, idx) => (
              <div
                key={idx}
                id={item.title}
                className="content"
                dangerouslySetInnerHTML={{ __html: item.content }}
              />
            ))}
          </ClientOnly>

          <ArticlesTitle>Other Articles</ArticlesTitle>

          <ArticlesBlock>
            {articles?.data?.map((item) => (
              <SmallCard type={type} key={item.id} item={item} />
            ))}
          </ArticlesBlock>
        </LeftSide>
        <RightSide>
          {sections && sections?.length > 1 && <TableContent data={sections} />}

          <ArticleCard
            onOpenModal={() => setIsModalOpened(true)}
            data={{
              image: image,
              title: 'All-In-One Home Services Management',
              mainTitle: 'Software',
            }}
          />
        </RightSide>
      </Content>
    </Wrapper>
  );
};

const Wrapper = styled.article`
  padding-bottom: 80px;
  & img {
    width: 100%;
    height: auto;

    max-width: 375px;
    max-height: 375px;
  }
  & .main-image {
    border-radius: 10px;
    width: 100%;
    max-width: 100%;
    object-fit: contain;
    height: 400px;
  }
`;

const ImageWrapper = styled.div`
  margin-bottom: 24px;
`;

const Title = styled.h1`
  color: #192d52;
  font-family: var(--font-roboto);
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
  margin-bottom: 12px;
  @media only screen and ${devices.desktop} {
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: 40px;
    margin-bottom: 8px;
  }
`;

const TimeStamp = styled.time`
  color: #4d4d4d;
  font-family: var(--font-roboto);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

const Content = styled.div`
  padding-top: 32px;
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  margin-bottom: 20px;
  @media only screen and ${devices.desktop} {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: start;
    gap: 20px;
  }
`;

const LeftSide = styled.div`
  width: 100%;
  & .content {
    padding-top: 32px;
    & p {
      color: #262626;
      font-family: var(--font-roboto);
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px;
    }
  }
`;
const RightSide = styled.div`
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 24px;
  @media only screen and ${devices.desktop} {
    width: 400px;
    position: sticky;
    top: 180px;
  }
`;

const ArticlesBlock = styled.div`
  display: flex;
  align-items: start;
  gap: 24px;
  flex-direction: column;
`;

const ArticlesTitle = styled.h4`
  color: #262626;
  font-family: var(--font-roboto);
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  margin: 40px 0 24px;
`;
